/* tslint:disable */
/* eslint-disable */
/**
 * MrbilitContent
 * Content management service for mrbilit website
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: badihi.2006@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { AppDeprecationsCountGet200Response } from '../model';
// @ts-ignore
import { NewUtmCampaign } from '../model';
// @ts-ignore
import { UtmCampaign } from '../model';
/**
 * UtmCampaignApiUtmCampaignsCountGet - axios parameter creator
 * 
 * @summary 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UtmCampaignApiUtmCampaignsCountGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/utm-campaigns/count`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UtmCampaignApiUtmCampaignsGet - axios parameter creator
 * 
 * @summary 
 * @param {number} [limit] Maximum number of results possible
 * @param {string} [sort] Sort according to a specific field.
 * @param {number} [start] Skip a specific number of entries (especially useful for pagination)
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UtmCampaignApiUtmCampaignsGetAxiosParamCreator (limit?: number, sort?: string, start?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/utm-campaigns`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (limit !== undefined) {
        localVarQueryParameter['_limit'] = limit;
    }

    if (sort !== undefined) {
        localVarQueryParameter['_sort'] = sort;
    }

    if (start !== undefined) {
        localVarQueryParameter['_start'] = start;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UtmCampaignApiUtmCampaignsIdDelete - axios parameter creator
 * Delete a record
 * @summary 
 * @param {string} id 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UtmCampaignApiUtmCampaignsIdDeleteAxiosParamCreator (id: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('utmCampaignsIdDelete', 'id', id)
    const localVarPath = `/utm-campaigns/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UtmCampaignApiUtmCampaignsIdGet - axios parameter creator
 * 
 * @summary 
 * @param {string} id 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UtmCampaignApiUtmCampaignsIdGetAxiosParamCreator (id: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('utmCampaignsIdGet', 'id', id)
    const localVarPath = `/utm-campaigns/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UtmCampaignApiUtmCampaignsIdPut - axios parameter creator
 * Update a record
 * @summary 
 * @param {string} id 
 * @param {NewUtmCampaign} newUtmCampaign 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UtmCampaignApiUtmCampaignsIdPutAxiosParamCreator (id: string, newUtmCampaign: NewUtmCampaign, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('utmCampaignsIdPut', 'id', id)
    // verify required parameter 'newUtmCampaign' is not null or undefined
    assertParamExists('utmCampaignsIdPut', 'newUtmCampaign', newUtmCampaign)
    const localVarPath = `/utm-campaigns/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(newUtmCampaign, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UtmCampaignApiUtmCampaignsPost - axios parameter creator
 * Create a new record
 * @summary 
 * @param {NewUtmCampaign} newUtmCampaign 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UtmCampaignApiUtmCampaignsPostAxiosParamCreator (newUtmCampaign: NewUtmCampaign, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'newUtmCampaign' is not null or undefined
    assertParamExists('utmCampaignsPost', 'newUtmCampaign', newUtmCampaign)
    const localVarPath = `/utm-campaigns`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearerAuth required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(newUtmCampaign, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for utmCampaignsGet operation in UtmCampaignApi.
 * @export
 * @interface UtmCampaignApiUtmCampaignsGetRequest
 */
export interface UtmCampaignApiUtmCampaignsGetRequest {
    /**
     * Maximum number of results possible
     * @type {number}
     * @memberof UtmCampaignApiUtmCampaignsGet
     */
    readonly limit?: number

    /**
     * Sort according to a specific field.
     * @type {string}
     * @memberof UtmCampaignApiUtmCampaignsGet
     */
    readonly sort?: string

    /**
     * Skip a specific number of entries (especially useful for pagination)
     * @type {number}
     * @memberof UtmCampaignApiUtmCampaignsGet
     */
    readonly start?: number
}

/**
 * Request parameters for utmCampaignsIdDelete operation in UtmCampaignApi.
 * @export
 * @interface UtmCampaignApiUtmCampaignsIdDeleteRequest
 */
export interface UtmCampaignApiUtmCampaignsIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof UtmCampaignApiUtmCampaignsIdDelete
     */
    readonly id: string
}

/**
 * Request parameters for utmCampaignsIdGet operation in UtmCampaignApi.
 * @export
 * @interface UtmCampaignApiUtmCampaignsIdGetRequest
 */
export interface UtmCampaignApiUtmCampaignsIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof UtmCampaignApiUtmCampaignsIdGet
     */
    readonly id: string
}

/**
 * Request parameters for utmCampaignsIdPut operation in UtmCampaignApi.
 * @export
 * @interface UtmCampaignApiUtmCampaignsIdPutRequest
 */
export interface UtmCampaignApiUtmCampaignsIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof UtmCampaignApiUtmCampaignsIdPut
     */
    readonly id: string

    /**
     * 
     * @type {NewUtmCampaign}
     * @memberof UtmCampaignApiUtmCampaignsIdPut
     */
    readonly newUtmCampaign: NewUtmCampaign
}

/**
 * Request parameters for utmCampaignsPost operation in UtmCampaignApi.
 * @export
 * @interface UtmCampaignApiUtmCampaignsPostRequest
 */
export interface UtmCampaignApiUtmCampaignsPostRequest {
    /**
     * 
     * @type {NewUtmCampaign}
     * @memberof UtmCampaignApiUtmCampaignsPost
     */
    readonly newUtmCampaign: NewUtmCampaign
}

/**
* 
* @summary 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UtmCampaignApiUtmCampaignsCountGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UtmCampaignApiUtmCampaignsCountGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<AppDeprecationsCountGet200Response> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary 
* @param {UtmCampaignApiUtmCampaignsGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UtmCampaignApiUtmCampaignsGet(requestParameters: UtmCampaignApiUtmCampaignsGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UtmCampaignApiUtmCampaignsGetAxiosParamCreator(requestParameters.limit, requestParameters.sort, requestParameters.start, options, configuration);
    const request: () => AxiosPromise<Array<UtmCampaign>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* Delete a record
* @summary 
* @param {UtmCampaignApiUtmCampaignsIdDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UtmCampaignApiUtmCampaignsIdDelete(requestParameters: UtmCampaignApiUtmCampaignsIdDeleteRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UtmCampaignApiUtmCampaignsIdDeleteAxiosParamCreator(requestParameters.id, options, configuration);
    const request: () => AxiosPromise<number> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary 
* @param {UtmCampaignApiUtmCampaignsIdGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UtmCampaignApiUtmCampaignsIdGet(requestParameters: UtmCampaignApiUtmCampaignsIdGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UtmCampaignApiUtmCampaignsIdGetAxiosParamCreator(requestParameters.id, options, configuration);
    const request: () => AxiosPromise<UtmCampaign> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* Update a record
* @summary 
* @param {UtmCampaignApiUtmCampaignsIdPutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UtmCampaignApiUtmCampaignsIdPut(requestParameters: UtmCampaignApiUtmCampaignsIdPutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UtmCampaignApiUtmCampaignsIdPutAxiosParamCreator(requestParameters.id, requestParameters.newUtmCampaign, options, configuration);
    const request: () => AxiosPromise<UtmCampaign> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* Create a new record
* @summary 
* @param {UtmCampaignApiUtmCampaignsPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UtmCampaignApiUtmCampaignsPost(requestParameters: UtmCampaignApiUtmCampaignsPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UtmCampaignApiUtmCampaignsPostAxiosParamCreator(requestParameters.newUtmCampaign, options, configuration);
    const request: () => AxiosPromise<UtmCampaign> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
